module.exports = new __parcel__URL__("CMIP-winter-median.7ce8c89e.jpeg").toString();